const Toast = () => {
    return(
        <div className="w-[360px] bg-[#323232]">
            <p className="text-[12px] font-semibold text-center p-4 text-[#FFFFFF]">Your money has been added to wallet</p>
        </div>
    )
}
export default Toast;